import React from 'react';
import { Box } from '@mui/material';
import logo from '../assets/hisar_logo.svg';
import { useInApp } from '../hooks/in-app';

type LoginLayoutProps = {
  children: React.ReactNode;
};

export default function LoginLayout({ children }: LoginLayoutProps) {
  const { inApp } = useInApp();

  return (
    <Box
      p={2}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 3,
      }}
    >
      {!inApp && <img src={logo} width={288.36} />}
      <Box
        sx={{
          mt: 4,
          px: [3, 8],
          py: 4,
          mx: 2,
          textAlign: 'center',
          width: ['100%', '360px'],
          boxShadow: '0 0 24px rgba(0, 0, 0, 0.125)',
          borderRadius: '10px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
